import type { MyActiveTaskProgress } from '@/features/tasks/api/watchTaskApi'
import type { TaskCardCta } from '@/features/tasks/taskCardCta'

const MODERATION_STATES = new Set([
  'submitted',
  'moderation',
  'under_review',
  'moderation_error'
])

export function isModeration(state: string | undefined): boolean {
  return MODERATION_STATES.has((state ?? '').trim().toLowerCase())
}

export function isModerationError(state: string | undefined): boolean {
  return (state ?? '').trim().toLowerCase() === 'moderation_error'
}

/** Action: store opened or install/signup webhook verification in flight. */
export function isActionTaskVerifying(state: string | undefined): boolean {
  const normalized = (state ?? '').trim().toLowerCase()
  return normalized === 'in_progress' || normalized === 'moderation'
}

export function isReservedGroup(state: string | undefined): boolean {
  const s = (state ?? '').trim().toLowerCase()
  return s === 'reserved' || MODERATION_STATES.has(s)
}

/** Active-tab section: all action attempts live under «Reserved»; share keeps share rules. */
export function isActiveTaskReservedGroup(
  cta: TaskCardCta,
  state: string | undefined
): boolean {
  if (cta === 'action') {
    return true
  }

  return isReservedGroup(state)
}

export function isReservedOnly(state: string | undefined): boolean {
  return (state ?? '').trim().toLowerCase() === 'reserved'
}

export function resolveActiveTaskDeadlineIso(
  progress: MyActiveTaskProgress,
  cta: TaskCardCta
): string | undefined {
  const stateRaw = (progress.state ?? '').trim().toLowerCase()

  if (
    (cta === 'share' || cta === 'create') &&
    stateRaw === 'in_progress' &&
    progress.views_deadline_at
  ) {
    return progress.views_deadline_at
  }

  if (cta === 'action') {
    const expiresAt = (progress.expires_at ?? '').trim()
    if (expiresAt) {
      return expiresAt
    }
  }

  return progress.available_until
}
